// extracted by mini-css-extract-plugin
export default {"dark-background":"Supplier_dark-background__qakhF"};